import React from 'react';

const RainbowTab = (props) => {
    return (
        <div className="rainbow-tab"></div>
    )
}

export default RainbowTab; 